import {
  Box,
  Button,
  CardContent,
  CircularProgress,
  Grid,
  Divider as MuiDivider,
  Paper,
  Stack,
  Typography,
  Card,
  Link,
  IconButton,
  FormControl,
  TextField,
  Tab,
  Tabs,
} from "@mui/material";
import { spacing } from "@mui/system";
import styled from "@emotion/styled";
import { Helmet } from "react-helmet-async";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import InfoIcon from "@mui/icons-material/Info";
import { AvvisiPage } from "./AvvisiPage";
import { API_BASE_URL } from "../../../config";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { fetchNotifications } from "../../../redux/slices/notifications";

const Divider = styled(MuiDivider)(spacing);

function Avvisi() {
  const [openModaleAggiungi, setOpenModaleAggiungi] = useState(false);
  const [openModaleLeggi, setOpenModaleLeggi] = useState(false);
  const [leggiData, setLeggiData] = useState({});
  const [pageSize, setPageSize] = useState(5);
  const [searchParam, setSearchParam] = useState("");
  const [tabValue, setTabValue] = useState(0);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Use global Redux notifications instead of local state
  const { items: rows, loading: loadingPage } = useSelector(
    (state) => state.notifications,
  );

  // Fetch notifications for this page only once on mount
  useEffect(() => {
    if (!loadingPage) {
      dispatch(fetchNotifications());
    }
  }, []);

  const handleSearch = (e) => {
    setSearchParam(e.target.value);
  };

  const filteredUsersList = rows.filter((row) =>
    (row.Titolo || "").toLowerCase().includes(searchParam.toLowerCase()),
  );

  const handleOpenModaleLeggi = (data) => {
    setLeggiData(data);
    setOpenModaleLeggi(true);
  };

  const columns = [
    {
      field: "idUid",
      headerName: "#",
      minWidth: 150,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "Titolo",
      headerName: "Titolo",
      minWidth: 500,
      headerAlign: "center",
      align: "left",
      renderCell: (params) => {
        return (
          <Box
            sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}
          >
            <IconButton
              size="small"
              sx={{
                margin: "0 8px",
              }}
            >
              <InfoIcon fontSize="small" />
            </IconButton>
            <Link href="" fontWeight="bold">
              {params.row.Titolo}
            </Link>
          </Box>
        );
      },
    },
    {
      field: "DataCreazione",
      headerName: "Creata",
      minWidth: 200,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "accettata",
      headerName: "Accettata",
      minWidth: 200,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "azioni",
      headerName: "Azioni",
      minWidth: 200,
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        return (
          <Box
            sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}
          >
            <Button
              variant={params.row.accettata === "S" ? "outlined" : "contained"}
              onClick={() => handleOpenModaleLeggi(params.row)}
            >
              Leggi
            </Button>
          </Box>
        );
      },
    },
  ];

  return (
    <>
      {loadingPage ? (
        <Box
          sx={{
            width: "calc(100vw - 40px)",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <>
          <Helmet title="Comunicazioni" />
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="h3" display="inline">
              Comunicazioni
            </Typography>
          </Box>
          <Divider my={4} />

          <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}>
            <Tabs
              value={tabValue}
              onChange={(e, val) => setTabValue(val)}
              aria-label="comunicazioni tabs"
            >
              <Tab label="Avvisi" />
              <Tab label="Notifiche" />
            </Tabs>
          </Box>

          <Box role="tabpanel" hidden={tabValue !== 0}>
            {tabValue === 0 && <AvvisiPage />}
          </Box>

          <Box role="tabpanel" hidden={tabValue !== 1}>
            {tabValue === 1 && (
              <>
                {/* 
                  NOTE: Re-enabled existing DataGrid for Notifiche tab. 
                  The user requested two tabs. We use existing grid for Notifiche.
                */}
                <Card mb={6}>
                  <CardContent pb={1}>
                    <Grid
                      container
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Grid item>
                        <Typography variant="h6" gutterBottom></Typography>
                      </Grid>
                      <Stack direction={"row"}>
                        <FormControl
                          sx={{ maxHeight: "30px", maxWidth: "200px" }}
                        >
                          <TextField
                            size="small"
                            type="text"
                            placeholder="Cerca per titolo"
                            onChange={(e) => handleSearch(e)}
                            sx={{
                              marginRight: "2rem",
                              maxHeight: "30px",
                              "& .MuiInputBase-root": {
                                height: "30px",
                              },
                              "& .MuiInputBase-input": {
                                height: "100%",
                                padding: "0 14px",
                              },
                            }}
                          />
                        </FormControl>
                        <Grid item>
                          <Button
                            mr={2}
                            variant="contained"
                            color="primary"
                            size="small"
                            onClick={() => setOpenModaleAggiungi(true)}
                          >
                            Nuovo Avviso
                          </Button>
                        </Grid>
                      </Stack>
                    </Grid>
                  </CardContent>
                  <Paper>
                    <div style={{ width: "100%" }}>
                      <DataGrid
                        autoHeight
                        pageSize={pageSize}
                        onPageSizeChange={(newPageSize) =>
                          setPageSize(newPageSize)
                        }
                        rowsPerPageOptions={[5, 10, 20]}
                        pagination
                        getRowId={(row) => row.idUid}
                        rows={filteredUsersList}
                        columns={columns}
                        editMode="row"
                        allowUpdating={true}
                        experimentalFeatures={{ newEditingApi: true }}
                        disableColumnMenu
                        disableSelectionOnClick
                        localeText={{ noRowsLabel: "Non ci sono risultati" }}
                        sx={{
                          "& .MuiDataGrid-columnHeader:focus, .MuiDataGrid-cell:focus":
                            {
                              outline: "none",
                            },
                          "& .MuiDataGrid-footerContainer": {
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "10px",
                          },
                        }}
                      />
                    </div>
                  </Paper>
                </Card>
              </>
            )}
          </Box>
        </>
      )}
    </>
  );
}

export default Avvisi;
